module.exports = __webpack_public_path__ + "static/media/next.34ad2c13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Paper/next.svg
// module id = 724
// module chunks = 3